export default __webpack_public_path__ + "static/tablet_sek2_KV17-5e045a3ff2d7ecf60aa97bd6112f2b26.mp4";